<template>
<div class="chapter">
<div class="inner_page">
<p class="paranoindent1"> </p>
<p class="paranoindent1"> </p>
<p class="paracenter"><em>Also by the same author</em></p>
<p class="paranoindent1"> </p>
<p class="paracenter">The Royal Navy and the Northwest Coast<br/>To the Pacific and Arctic with Beechey<br/>The Northwest Coast: British Navigation, Trade and Discoveries<br/>Gunboat Frontier<br/>HMCS HAIDA: Battle Ensign Flying<br/>Fighting Sail on Lake Huron and Georgian Bay<br/>Fortune’s a River: Collision of Empires in Northwest America</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Dedication.vue?5b9ee880